export enum InStudioView {
  Preview = 'preview',
  Takeover = 'takeover',
}
